import * as React from 'react';

import {useLogoutMutation} from '../../hooks/user/use-logout-mutation';
import {getLoginUrlWithLastLocation} from '../../utils/login';

export function LogoutItem(props: {
    children: React.ReactElement<{onClick: () => Promise<void>; disabled: boolean}>;
}) {
    const logoutMutation = useLogoutMutation();

    const handleSignOutClick = async () => {
        await logoutMutation.mutateAsync();

        window.location.href = getLoginUrlWithLastLocation();
    };

    return React.cloneElement(props.children, {
        onClick: handleSignOutClick,
        disabled: logoutMutation.isPending
    });
}
